/**
 * 群设置主页懒加载壳（14.25b；FriendDetailLazy 同构）：低频页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function GroupSettingsLazy({ groupId }: { groupId: number }) {
  const { mod } = useLazyModule(() => import('./GroupSettingsPage'));
  if (mod === null) return <div data-testid="group-settings-loading-shell">加载中…</div>;
  return <mod.GroupSettingsPage groupId={groupId} />;
}
